<template>
  <v-card>
    <v-card-text>Table List</v-card-text>
    <List />
    <Edit />
    <New />
    <SingleQRDialog />
    <MultipleQRDialog />
    <v-btn
      @click="va_create(true)"
      fixed
      depressed
      dark
      fab
      bottom
      right
      color="primary"
      :style="$root.rightNav?'margin-right:260px; margin-bottom:30px;':'margin-bottom:30px;'"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import List from './List.vue'
import Edit from './Edit.vue'
import New from './New.vue'
import SingleQRDialog from '@/components/custom-components/SingleQRDialog.vue'
import MultipleQRDialog from '@/components/custom-components/MultipleQRDialog'
export default {
  components: {
    List,
    Edit,
    New,
    SingleQRDialog,
    MultipleQRDialog
  },
  methods: {
    ...mapMutations({
      va_create: 'table/SET_DIALOG_CREATE'
    })
  }
}
</script>

<style lang="scss" scoped>
</style>
